import { Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router";
import ScrollToTopOnNavigate from "./components/ScrollToTopOnNavigate";
import SeoHead from "../lib/seo/SeoHead";
import Home from "./pages/Home";

function RootLayout() {
  return (
    <>
      <SeoHead />
      <ScrollToTopOnNavigate />
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", Component: Home },
      {
        path: "/privacy-policy",
        lazy: async () => {
          const { default: Component } = await import("./pages/PrivacyPolicy");
          return { Component };
        },
      },
      {
        path: "/cookie-policy",
        lazy: async () => {
          const { default: Component } = await import("./pages/CookiePolicy");
          return { Component };
        },
      },
      {
        path: "/products/nisium",
        lazy: async () => {
          const { default: Component } = await import("./pages/products/Nisium");
          return { Component };
        },
      },
      {
        path: "/products/silopass",
        lazy: async () => {
          const { default: Component } = await import("./pages/products/SiloPass");
          return { Component };
        },
      },
      {
        path: "/products/xngo",
        lazy: async () => {
          const { default: Component } = await import("./pages/products/XnGo");
          return { Component };
        },
      },
      {
        path: "/services/ai-architecture",
        lazy: async () => {
          const { default: Component } = await import("./pages/services/AiArchitecture");
          return { Component };
        },
      },
      {
        path: "/brand",
        lazy: async () => {
          const { default: Component } = await import("./pages/BrandAssets");
          return { Component };
        },
      },
      {
        path: "*",
        lazy: async () => {
          const { default: Component } = await import("./pages/NotFound");
          return { Component };
        },
      },
    ],
  },
]);
